const compareOptions = (a, b) => {
  const labelA = a.label.toUpperCase();
  const labelB = b.label.toUpperCase();

  let comparison = 0;
  if (labelA > labelB) {
    comparison = 1;
  } else if (labelA < labelB) {
    comparison = -1;
  }
  return comparison;
};

const formatOptions = opts => {
  if (opts === null || opts.length === 0) return [];
  return opts.map(opt => ({ value: opt.id, label: opt.name })).sort(compareOptions);
};

export default formatOptions;



// WEBPACK FOOTER //
// ./app/javascript/app/utils/formatters/formatOptions.js